import { render, staticRenderFns } from "./meiriYts.vue?vue&type=template&id=2c4b9dc2&scoped=true"
import script from "./meiriYts.vue?vue&type=script&lang=js"
export * from "./meiriYts.vue?vue&type=script&lang=js"
import style0 from "./meiriYts.vue?vue&type=style&index=0&id=2c4b9dc2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c4b9dc2",
  null
  
)

export default component.exports